import React from "react";
import Skeleton from "react-loading-skeleton";

const ReservationSkeleton = () => {
    return (
        <div className="col-md-12 as-col-table-container">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">First Name</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Last Name</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Email</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Phone</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Desired date</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Property/Project Name</th>
                        {/* <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Statut</th> */}
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ReservationSkeleton;